import axios from 'lib/utils/axios';
import validate from 'lib/utils/validationRules';

import HTTPService from 'services/Http';
import { getLocaleCode as getLanguageCode } from 'services/i18n-setup';
import getMeta from 'api/requests/meta/getMeta';

import { EVENT_BUS } from '@/eventBus';

export default {
  GET_PROJECT({ commit, dispatch }, projectId) {
    commit('CLEAR_ALL_STATE');

    return HTTPService.getProject(projectId)
      .then(response => commit('SET_PROJECT', response.data));
  },

  GET_BILL({ commit, dispatch }, billCode) {
    commit('CLEAR_ALL_STATE');

    return HTTPService.getBill(billCode)
      .then(response => commit('SET_PROJECT', response.data));
  },

  SAVE_BILL({ commit }, data) {
    commit('SET_PROJECT', data);
  },

  async GET_BILL_CONTENT({ commit, dispatch }, publicId) {
    commit('CLEAR_ALL_STATE');

    return HTTPService.getContentBill(publicId)
      .then(response => commit('SET_TRANSACTION', response.data))
      .catch(error => {
        const { data } = error;

        if (validate.isNotEmptyObject(data)) {
          commit('SET_TRANSACTION', data);
        }

        throw error;
      });
  },

  PROJECT_PAYMENT_CREATE({ commit }, data) {
    return HTTPService.projectPaymentCreate(data);
  },

  async GET_PROJECT_LOCALE({ commit }, payload) {
    const languageCode = getLanguageCode(false);

    const localeParams = languageCode
      ? { language: languageCode }
      : { ...payload };

    try {
      const { data } = await HTTPService.getProjectLocale(localeParams);
      EVENT_BUS.$emit('change.locale', data.language);

      return data;
    } catch (error) {
      console.log(error);
    }
  },

  async GET_PAYMENT({ commit }, { paymentId, processToken }) {
    try {
      const { data } = await HTTPService.getPaymentStatus(paymentId, processToken);

      commit('CLEAR_ALL_STATE');
      commit('SET_TRANSACTION', data);
    } catch (error) {
      console.error(error);

      throw new Error(error);
    }
  },

  async GET_PAYMENT_ORIGIN({ commit }, publicId) {
    try {
      const { data } = await HTTPService.getPaymentOrigin(publicId);

      commit('SET_PAYMENT_ORIGIN', data);
    } catch (error) {
      console.error(error);

      throw new Error(error);
    }
  },

  async GET_METADATA({ commit }) {
    try {
      const { data } = await getMeta(axios);

      commit('SET_METADATA', data);
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  },
};
